import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import { Search, X } from 'react-bootstrap-icons';
import { useDispatch } from 'react-redux';
import InputGroup from 'react-bootstrap/InputGroup';
import Popover from 'react-bootstrap/Popover';

import PropertiesByCategoryMultiSelectFilter from './PropertiesByCategoryMultiSelectFilter';

import { MAX_AMOUNT_SELECTED } from '../../../Constants/Interest/Filter';
import { Filter } from '../../../Enum/Filters';

import useGetPropertiesByCategory from '../../../Hook/ProductProperties/UseGetPropertiesByCategory';
import useGetFilterValue from '../../../Hook/Interest/UseGetFilterValue';
import { filterChanged } from '../../../Store/Filter/action';
import { getFilteredProperties } from '../../../Service/ProductPropertiesService';

interface State {
    showPopover: boolean;
    keyword: string;
}

const PropertiesByCategoriesMultiSelectFilter: React.FC = () => {
    const dispatch = useDispatch();
    const [state, setState] = useState<State>({ showPopover: false, keyword: '' });
    const propertiesByCategories = useGetPropertiesByCategory();
    const filteredPropertiesByCategories = getFilteredProperties(propertiesByCategories, state.keyword);
    const propertiesInFilter = useGetFilterValue(Filter.MortgageProperties) as string[];

    const getPropertyName = (propertyCode: string): string =>
        propertiesByCategories.reduce(
            (acc, currValue) => {
                const property = currValue.properties.find(prop => propertyCode === prop.code);
                if (property !== undefined) {
                    acc = property.name;
                }
                return acc;
            },
            ''
        );

    const disabled = propertiesInFilter.length === MAX_AMOUNT_SELECTED;

    const toggleProperty = (propertyCode: string): void => {
        if (disabled && !propertiesInFilter.includes(propertyCode)) {
            return;
        }

        dispatch(filterChanged(
            Filter.MortgageProperties,
            !propertiesInFilter.includes(propertyCode)
                ? [...propertiesInFilter, propertyCode]
                : propertiesInFilter.filter(code => code !== propertyCode)
        ));
    }

    return (
        <>
            <Form className="popover-select-form" autoComplete="off">
                <Form.Group controlId="property-select">
                    <Form.Label>Zoek je voorwaarde</Form.Label>
                    <InputGroup>
                        <InputGroup.Prepend>
                            <InputGroup.Text>
                                <Search />
                            </InputGroup.Text>
                        </InputGroup.Prepend>
                        <Form.Control
                            type="text"
                            className="rounded-right"
                            placeholder="Voorwaarde"
                            onChange={(e: any) => setState({ ...state, keyword: e.target.value })}
                            onFocus={() => setState({ ...state, showPopover: true })}
                        />
                        {filteredPropertiesByCategories.length > 0 && state.showPopover && (
                            <>
                                <div
                                    className="popover-backdrop"
                                    onClick={() => setState({ ...state, showPopover: false })}
                                    onKeyDown={() => setState({ ...state, showPopover: false })}
                                />
                                <Popover id="property-select-popover" className="select" content placement="bottom">
                                    {filteredPropertiesByCategories.map(category => (
                                        <PropertiesByCategoryMultiSelectFilter category={category}
                                                                               disabled={disabled}
                                                                               key={category.name}
                                                                               toggleProperty={toggleProperty}
                                        />
                                    ))}
                                </Popover>
                            </>
                        )}
                    </InputGroup>
                </Form.Group>
            </Form>
            {propertiesInFilter.length > 0 && (
                <>
                    {propertiesInFilter.map(code => (
                        <div className="selected-value-wrapper labels no-ellipsis" key={`selected-${code}`}>
                            <div
                                className="selected-value-wrapper__value"
                                onClick={() => toggleProperty(code)}
                                onKeyDown={() => toggleProperty(code)}
                            >
                                {getPropertyName(code)}
                                <X />
                            </div>
                        </div>
                    ))}
                    <hr className="mb-2 mt-2" />
                </>
            )}
        </>
    );
};

export default PropertiesByCategoriesMultiSelectFilter;
